export default __webpack_public_path__ + "static/media/Group_8418.82f4a8f3.svg";